import React, { useContext, useCallback } from 'react';
import { Button } from '@ontruck/orc';
import SetToManualFlowContext, {
  SetToManualFlowContextProvider,
} from 'modules/set-to-manual-flow/context';
import { setSelfChangedData } from 'redux/modules/realtime/effects';
import { useDispatch } from 'react-redux';

import { fetchJourney as fetchJourneyRequest } from 'redux/modules/journeys/http';

const t = {
  body: 'This job is following the automatic flow.',
  button: 'Set job to manual',
};

const JobAutomaticFlow = ({ id }) => {
  const dispatch = useDispatch();
  const { openModal } = useContext(SetToManualFlowContext);

  const afterSubmit = useCallback(async () => {
    const shipperOrder = await fetchJourneyRequest(id);
    dispatch(setSelfChangedData({ model: 'journey', data: shipperOrder }));
  }, [id, dispatch]);

  const handleOpen = useCallback(() => {
    openModal(id, {
      afterSubmit,
    });
  }, [openModal, id, afterSubmit]);

  return (
    <div>
      <div style={{ marginBottom: 16 }}>{t.body}</div>
      <div>
        <Button onClick={handleOpen}>{t.button}</Button>
      </div>
    </div>
  );
};

const JobAutomaticFlowProvider = (props) => {
  return (
    <SetToManualFlowContextProvider model="journey">
      <JobAutomaticFlow {...props} />
    </SetToManualFlowContextProvider>
  );
};

export default JobAutomaticFlowProvider;
